import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { SpecimensPayload } from './index.model'
import { CORE_API_ENTRYPOINT, customHeaders } from '../../services.helpers'

export const specimensApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: '' }),
  endpoints: (builder) => ({
    postSpecimens: builder.mutation<{ route; }, SpecimensPayload>({
      query: ({
        appointmentTime,
        dateOfBirth,
        gender,
        menstrualPhaseAtCollection,
        patientEventId,
        sampleId,
        testStartTime,
        timeOfTheDayCondition,
      }) => ({
        body: {
          ...(dateOfBirth && { dateOfBirth: dateOfBirth }),
          ...(gender && { gender: gender }),
          ...(testStartTime && { testStartTime: testStartTime }),
          ...(appointmentTime && { appointmentTime: appointmentTime }),
          ...(menstrualPhaseAtCollection && { menstrualPhaseAtCollection: menstrualPhaseAtCollection }),
          ...(patientEventId && { patientEventId: patientEventId }),
          ...(sampleId && { sampleId: sampleId }),
          ...(timeOfTheDayCondition && { timeOfTheDayCondition: timeOfTheDayCondition }),
        },
        headers: customHeaders(),
        method: 'POST',
        url: `${CORE_API_ENTRYPOINT}/api/specimens`,
      }),
    }),
  }),
  reducerPath: 'specimensApi',
})

export const usePostSpecimens = specimensApi.endpoints.postSpecimens.useMutation
